import { render, staticRenderFns } from "./DahsboardDepositsComponent.vue?vue&type=template&id=33b0bf4d&scoped=true"
import script from "./DahsboardDepositsComponent.vue?vue&type=script&lang=js"
export * from "./DahsboardDepositsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0bf4d",
  null
  
)

export default component.exports